import { useContext } from "react";
import { TempAuthContext } from "./TempAuthProvider";

const useTempAuth = () => {
    const {  setToken, setUser, token, user } = useContext(TempAuthContext);

    const clearAuth = () => {
        setToken(null);
        setUser(null);
    }

    return { setToken, setUser, clearAuth, tempAuthenticated: !!token && !!user, token };
}

export default useTempAuth;